import React from 'react';
import { PropTypes, describe } from 'react-desc';

var DSCardBody = function DSCardBody(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "em-ds-card-body",
    "data-testid": "card-body"
  }, children);
};

var bodyProps = {
  /** children */
  children: PropTypes.element.description('children')
};
DSCardBody.propTypes = bodyProps;
var DSCardBodyWithSchema = describe(DSCardBody);
DSCardBodyWithSchema.propTypes = bodyProps;

export default DSCardBody;
export { DSCardBody, DSCardBodyWithSchema };
//# sourceMappingURL=DSCardBody.js.map
